"use client";

import { useContext, useEffect, useState } from "react";
import { clientPost } from "@/service/client-api/client-api";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { HomeEbookBanner } from "./home-ebook-banner";
import { HomeVirtualOfficeBanner } from "./home-virtual-office-banner";
import { HomeRoadmapBanner } from "./home-roadmap-banner";
import { HomeBannerBloodDonor } from "./home-banner-blood-donor";
import { HomeBannerChannels } from "./home-banner-channels";
import { HomeKlubMedykaBanner } from "./home-klub-medyka-banner";
import { HomePracticeExamBanner } from "./home-practice-exam-banner";
import { HomePkwpozBanner } from "./home-pkwpoz-banner";
import { PKWPOZ_BANNER_KEY } from "./home-pkwpoz-banner-constants";
import { HomeEkgBanner } from "./home-ekg-banner";

interface HomeBanner
  extends React.FC<{
    closeBanner: () => void;
  }> {}

const banners: Record<string, { component: HomeBanner }> = {
  Ebook: {
    component: HomeEbookBanner,
  },
  VirtualOffice: {
    component: HomeVirtualOfficeBanner,
  },
  Roadmap: {
    component: HomeRoadmapBanner,
  },
  BloodDonor: {
    component: HomeBannerBloodDonor,
  },
  Channels: {
    component: HomeBannerChannels,
  },
  Club: {
    component: HomeKlubMedykaBanner,
  },
  // klucz kampanii = konkretna edycja próbnego LEK-u; kolejna edycja dostaje nowy klucz
  "probny-lek-2-2026": {
    component: HomePracticeExamBanner,
  },
  // klucz kampanii = jesienna edycja "Pierwsze kroki w POZ" (konferencja 3 września)
  [PKWPOZ_BANNER_KEY]: {
    component: HomePkwpozBanner,
  },
  "home-ekg": {
    component: HomeEkgBanner,
  },
  // Ksef: {
  //   component: HomeKsefBanner,
  // },
  // CinemaCity: {
  //   component: HomeCinemaCityBanner,
  // },
};

export const HomeBannerRouter = ({
  bannerId,
  bannerKey,
}: {
  bannerId: number;
  bannerKey: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const { logView } = useContext(ResourceContext);
  const isKnownBanner = !!banners[bannerKey];

  useEffect(() => {
    if (isKnownBanner) {
      logEvent("home_banner_view", logView, {
        banner_id: bannerId,
        banner_key: bannerKey,
      });
    }
  }, [bannerId, bannerKey, isKnownBanner, logView]);

  const bannerClose = () => {
    setIsOpen(false);
    logEvent("home_banner_exit_click", logView, {
      banner_id: bannerId,
      banner_key: bannerKey,
    });
    clientPost("communication-audience.banner.dismiss", { id: bannerId });
  };

  if (!isOpen || !banners[bannerKey]) {
    return null;
  }

  console.log("Rendering banner with key:", bannerKey);

  const BannerComponent = banners[bannerKey].component;
  return <BannerComponent closeBanner={bannerClose} />;
};
